import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/libs/ui-components/src/lib/FeaturedVisualizable.tsx");
